module.exports = __webpack_public_path__ + "static/media/button filters.6d2d685a.svg";